import {Button, Col, DatePicker, Form, Input, InputNumber, Row, Select} from 'antd';
import React from 'react';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const DetailKeyActivity = () => {
	const apiList = [Arguments.host + '/society_organization/society/api!addKeyActivity.do'];
	return (
		<EditFormComponent UserForm={KeyActivityForm} url={apiList}/>
	);
};

const KeyActivityForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 1200, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityName" label="活动名称" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="activitySubject" label="活动主题"
					>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="activityUnit" label="主办单位"
						rules={[{required: true, validator: validateWhiteSpace}]}
					>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="organizer" label="承办单位">
						<Input disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="coOrganizer" label="协办单位">
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="activityDate" label="活动时间"
						rules={[{required: true, message: '内容不能为空'}]}
					>
						<DatePicker disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="activityScope" label="活动规模（人）"
						rules={[{required: true, message: '内容不能为空'}]}
					>
						<InputNumber min={0} style={{width: 150}} disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityAddress" label="活动地址"
						rules={[{required: true, validator: validateWhiteSpace}]}
					>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="activityForm" label="活动形式"
						rules={[{required: true, message: '内容不能为空'}]}
						initialValue="报告会"
					>
						<Select disabled={true}>
							<Select.Option value="报告会">报告会</Select.Option>
							<Select.Option value="研讨会">研讨会</Select.Option>
							<Select.Option value="座谈会">座谈会</Select.Option>
							<Select.Option value="论坛">论坛</Select.Option>
							<Select.Option value="讲座">讲座</Select.Option>
							<Select.Option value="调研">调研</Select.Option>
							<Select.Option value="科普">科普</Select.Option>
							<Select.Option value="其他">其他</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="activityOutcome" label="成果形式"
						rules={[{required: true, message: '内容不能为空'}]}
						initialValue="媒体报道"
					>
						<Select disabled={true}>
							<Select.Option value="媒体报道">媒体报道</Select.Option>
							<Select.Option value="公开出版">公开出版</Select.Option>
							<Select.Option value="内部资料">内部资料</Select.Option>
							<Select.Option value="其他">其他</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>


			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityMemo" label="活动说明"
						rules={[{required: true, message: '内容不能为空'}]}
					>
						<div style={{marginTop: 4}} dangerouslySetInnerHTML={{__html: initialValues.activityMemo}}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button
					type="primary"
					htmlType="button"
					onClick={() => {
						window.history.back();
					}}
				>
					返回
				</Button>
			</Form.Item>
		</Form>
	);
};

export default DetailKeyActivity;
